module.exports = __webpack_public_path__ + "static/media/cruise.7e0cb8d0.jpg";